export default {
  activeDay: null,
  activePeriod: null
};
